module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "part",
      "title": "SECTION I: THE CHALLENGE: Carbon-Based, Analog, Feeling Humans in a Silicon-Infused, Digital, Data-Driven World"
    }
  }, [_c('p', {
    staticClass: "secno",
    attrs: {
      "id": "pa1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('b', [_vm._v("SECTION I")])])])]), _vm._v(" "), _c('p', {
    staticClass: "sectitle"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_vm._v("THE CHALLENGE:")])]), _vm._v(" "), _c('p', {
    staticClass: "secsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_c('i', [_vm._v("Carbon-Based, Analog, Feeling Humans in a Silicon-Infused, Digital, Data-Driven World")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-387e2506","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9781400210664_Section1.vue
// module id = 81
// module chunks = 0